import { VariantSelector } from "./variant-selector";

export const SEL_SWATCH_CONTAINER = '[data-swatches]';
const SEL_SWATCH = '[data-swatch]';
const SEL_SWATCH_OBJECT = '[data-swatch-object]';
const SEL_SWATCH_DROPDOWN = '[data-swatch-dropdown]';
const SEL_SWATCH_VALUE = '[data-swatch-value]';

const ATTR_POSITION = 'data-swatch-position';
const ATTR_VALUE = 'data-value';

const CLASS_SELECTED = 'is-selected';

export class Swatches extends VariantSelector {
  public readonly swatches:HTMLDivElement[];

  constructor(container:HTMLElement, updateHistory?:boolean) {
    super(container, updateHistory);
    this.swatches = Array.from(container.querySelectorAll<HTMLDivElement>(SEL_SWATCH).values());

    // Listen for button presses
    this.container.querySelectorAll<HTMLElement>(SEL_SWATCH_OBJECT).forEach(btn => {
      btn.addEventListener('click', this.onSwatchClick);
    });

    // Listen for dropdown changes
    this.container.querySelectorAll<HTMLSelectElement>(SEL_SWATCH_DROPDOWN).forEach(dd => {
      dd.addEventListener('change', this.onDropdownChange)
    });

    this.onVariantSelected();
  }

  private onSwatchClick = (e:MouseEvent) => {
    const btn = e.currentTarget as HTMLElement;
    const swatch = btn.closest(SEL_SWATCH);
    if(!swatch) return;

    const attrPosition = parseInt(swatch.getAttribute(ATTR_POSITION)||'');
    const attrValue = btn.getAttribute(ATTR_VALUE);
    if(isNaN(attrPosition) || !attrValue) return;

    this.setVariantOption(attrPosition - 1, attrValue);
  }

  private onDropdownChange = (e:Event) => {
    const sel = e.currentTarget as HTMLSelectElement;
    const swatch = sel.closest(SEL_SWATCH);
    if(!swatch) return;
    const attrPosition = parseInt(swatch.getAttribute(ATTR_POSITION)||'');
    if(isNaN(attrPosition)) return;
    this.setVariantOption(attrPosition - 1, sel.value);
  }

  public onVariantSelected() {
    const variant = this.getVariant();

    this.swatches.forEach(swatch => {
      const attrPosition = parseInt(swatch.getAttribute(ATTR_POSITION)||'');
      if(isNaN(attrPosition)) return;
      const value = variant.options[attrPosition - 1];

      // Update btn classes
      const objs = swatch.querySelectorAll<HTMLElement>(SEL_SWATCH_OBJECT);
      objs.forEach(obj => {
        const objVal = obj.getAttribute(ATTR_VALUE);
        if(objVal === value) {
          obj.classList.add(CLASS_SELECTED);
          let parent = obj.parentElement;
          if(parent){
            parent.classList.add(CLASS_SELECTED);
          }
    
        } else {
          obj.classList.remove(CLASS_SELECTED);
          let parent = obj.parentElement;
          if(parent){
            parent.classList.remove(CLASS_SELECTED);
          }
        }
      });

      // Update dropdowns
      const sels = swatch.querySelectorAll<HTMLSelectElement>(SEL_SWATCH_DROPDOWN);
      sels.forEach(sel => sel.value = value);

      // Update title(s)
      swatch.querySelectorAll<HTMLElement>(SEL_SWATCH_VALUE).forEach(sv => {
        sv.textContent = value;
      });
    });
  }

  public dispose() {
    super.dispose();

    this.container.querySelectorAll<HTMLElement>(SEL_SWATCH_OBJECT).forEach(btn => {
      btn.removeEventListener('click', this.onSwatchClick);
    });

    this.container.querySelectorAll<HTMLSelectElement>(SEL_SWATCH_DROPDOWN).forEach(dd => {
      dd.removeEventListener('change', this.onDropdownChange);
    });
  }
}
